import React from "react";
import '../../css/Footer.css'
import {Link} from "react-router-dom";
const Footer=()=>{

    return(
        <div className={'footer-container'}>
            <div>
                <div className={'row-box'}>
                    <Link to={'/privacy'} className={'nav-text'} style={{cursor:'pointer',color:'red'}}><span>개인정보 처리방침</span></Link>
                    <p>|</p>
                    <Link to={'#'} className={'nav-text'} style={{cursor:'pointer'}}><span
                        onClick={()=>{
                            window.open('https://www.ftc.go.kr/www/bizCommList.do?key=232', '_blank')
                        }}>사업자정보 확인</span></Link>
                    <p>|</p>
                    <Link to={'/manager-page'} className={'nav-text'} style={{cursor:'pointer'}}><span>관리자 페이지</span></Link>
                </div>
                <div className={'row-box'}>
                    <span>대표자: 임창범    사업자등록번호: 472-16-01976   고객센터: 0507-1352-6572</span>
                </div>
                <div className={'row-box'}>
                    <span>주소: 제주특별자치도 제주시 용남1길 16 1층 제주앙</span>
                </div>
            </div>
            <div>
                <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt={'logo'} width={80}/>
            </div>
        </div>
    );
}

export default Footer;
